import { SessionStorageEntityIdResolver } from '../../resolvers/session-storage-entityid/session-storage-entityid.resolver';

export const callbackRoute = {
  path: 'callback',
  url: '/callback',
  pathMatch: 'full',
  authenticationRequired: false,
  redirectTo: '/district-picker',
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
};
